module.exports = __webpack_public_path__ + "img/4ne.9ef7930b.svg";